module.exports = __webpack_public_path__ + "static/media/pks_new.67fb15c8.png";